import React, { Fragment } from 'react';
import Countdown, { doubleDigit } from 'react-downcount';

const endDate = new Date('2019-03-30');

const customRenderer = ({ days, hrs, mins, secs, isCompleted }) => {
  return isCompleted
    ? ''
    : <Fragment>
      <div className="segment">
        <span className="number">{days}</span>
        <span className="unit">days</span>
      </div>
      <div className="segment">
        <span className="number">{hrs}</span>
        <span className="unit">hours</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(mins)}</span>
        <span className="unit">min</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(secs)}</span>
        <span className="unit">sec</span>
      </div>
    </Fragment>
}

class Hero extends React.Component {
  goRegister() {
    const target = document.getElementById("register");
    target.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  render() {
    return (
      <section id="hero">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <img src="images/hero-image.png" alt="National Data Science Challenge logo" className="hero-image" />
              <p className="date">23 Feb - 30 Mar 2019</p>
              <Countdown
                className="countdown"
                endDate={endDate}
              >
                {customRenderer}
              </Countdown>
              <h1>The <b>largest</b> data science competition in Singapore</h1>
              <button title="Go to Register" onClick={this.goRegister} className="btn btn-primary">Register Now</button>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        </div>
      </section>
    )
  }
};

export default Hero;
